module.exports = __webpack_public_path__ + "static/font-e9207cf10190ad3f08549dbf1b0ec1fe.woff";